import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  Info, 
  Phone 
} from 'lucide-react';
import './Rules.css';

const rulesData = [
  {
    title: "Timings",
    description: "Study room timings: 7:00 AM to 11:00 PM.",
  },
  {
    title: "Fees & Payments",
    description: "Monthly fees must be paid by the 5th. Payment after the 15th attracts a ₹100 late fee.",
  },
  {
    title: "Footwear",
    description: "Keep your slippers and shoes in the designated place outside.",
  },
  {
    title: "Silence & Gadgets",
    description: "Use headphones while using mobile phones or laptops. Maintain silence.",
  },
  {
    title: "Belongings",
    description: "Take care of your belongings. Management is not responsible for any loss.",
  },
  {
    title: "Save Energy",
    description: "Switch off fans and lights if not required.",
  },
  {
    title: "Cleanliness",
    description: "Do not write on tables or walls. Dispose of waste in appropriate bins.",
  },
  {
    title: "Management Rights",
    description: "Management reserves the right to allow or deny entry.",
  }
];

const RuleItemCard = ({ number, rule }) => {
  return (
    <div className="rule-card">
      <div className="rule-number-circle" aria-label={`Rule ${number}`}>{number}</div>
      <div className="rule-text-content">
        <h4 className="rule-title">{rule.title}</h4>
        <p className="rule-description">{rule.description}</p>
      </div>
    </div>
  );
};

const Rules = () => {
  const navigate = useNavigate();

  return (
    <div className="rules-screen">
      
      {/* -------- HEADER SECTION -------- */}
      <div className="rules-header">
        {/* Floating Back Button over the gradient */}
        <button onClick={() => navigate(-1)} className="floating-back-btn">
          <ArrowLeft size={24} color="white" />
        </button>

        <div className="header-content">
          <div className="logo-circle-wrapper">
            <img 
              src="/assets/logo.png" 
              alt="Logo" 
              className="header-logo"
            />
          </div>
          <h1 className="header-title">Rules & Regulations</h1>
          <p className="header-subtitle">Guidelines for a disciplined environment</p>
        </div>
      </div>

      {/* -------- CONTENT BODY -------- */}
      <div className="rules-body">
        
        {/* Introduction Card */}
        <div className="intro-card">
          <Info size={24} color="var(--brand-blue)" className="intro-icon" />
          <p className="intro-text">
            Please follow these rules strictly to maintain a focused study atmosphere.
          </p>
        </div>

        {/* List of Rules */}
        <div className="rules-list">
          {rulesData.map((rule, index) => (
            <RuleItemCard key={index} number={index + 1} rule={rule} />
          ))}
        </div>

        <hr className="rules-divider" />

        {/* Contact Section (HTML Native Dialer) */}
        <a href="tel:7410517553" className="contact-card-link">
          <div className="contact-card">
            <span className="contact-label">Have Issues or Complaints?</span>
            <div className="contact-row">
              <Phone size={20} color="var(--brand-blue)" />
              <span className="contact-number">7410517553</span>
            </div>
          </div>
        </a>
        
        {/* Bottom padding spacer */}
        <div style={{ height: '30px' }}></div>

      </div>
    </div>
  );
};

export default Rules;
